<ds-community-search-result-list-element [object]="object"
                                         [index]="index"
                                         [linkType]="linkType"
                                         [listID]="listID"></ds-community-search-result-list-element>
<div>
    <a class="btn btn-light mt-1" [routerLink]="[editPath]">
        <i class="fa fa-edit"></i> {{"admin.search.community.edit" | translate}}
    </a>
</div>
